import "./styles.css";
import { FormControlLabel, Switch, SwitchProps } from "@mui/material";
import { ReactNode, useState } from "react";

function SwitchInput({
  label,
  onChange,
  className,
  style,
  ...rest
}: SwitchProps & { label?: ReactNode }) {
  const [checked, setChecked] = useState(false);
  return (
    <FormControlLabel
      label={label ?? ""}
      control={
        <Switch
          onChange={(e, checked) => {
            setChecked(checked);
            if (onChange) onChange(e, checked);
          }}
          className={"switch-input " + (className ?? "")}
          style={{
            ...{
              "--fg-color": checked
                ? "var(--color-fasmr-blue)"
                : "var(--color-dark)",
            },
            ...style,
          }}
          {...rest}
        />
      }
    />
  );
}

export default SwitchInput;
